import { memo } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { StaticVerticalStepperContent } from '@frontend/static-vertical-stepper';
import { theme } from '@frontend/theme';
import { Heading, Text } from '@frontend/design-system';

type PrintHistoryProps = {
  history: StaticVerticalStepperContent[];
};

export const PrintHistory = memo(({ history }: PrintHistoryProps) => {
  const { t } = useTranslation('insurance-eligibility-report');
  if (!history || history.length === 0) {
    return null;
  }

  return (
    <div css={historyCardStyles}>
      <Heading level={2} css={headerStyles}>
        {t('History')}
      </Heading>
      <div css={unorderedListStyles}>
        <ul>
          {history.map((step) => {
            return (
              <div className='step-text' key={step.subTitle}>
                <Text
                  as='li'
                  size='large'
                  css={css({
                    whiteSpace: 'pre-wrap',
                    flex: 1,
                  })}
                >
                  {step.title}
                </Text>
                <Text size='small' weight='light' css={{ fontStyle: 'italic' }}>
                  {step.subTitle}
                </Text>
              </div>
            );
          })}
        </ul>
      </div>
    </div>
  );
});

PrintHistory.displayName = 'PrintHistory';

const historyCardStyles = css`
  flex: 1;
  border: 1px solid ${theme.colors.neutral20};
  border-radius: ${theme.borderRadius.medium};
`;
const unorderedListStyles = css`
  padding: ${theme.spacing(2)};
  padding-left: ${theme.spacing(1)};
`;
const headerStyles = css`
  padding: 2px 0 0 ${theme.spacing(2)};
  background-color: ${theme.colors.neutral5};
  border-bottom: 1px solid ${theme.colors.neutral20};
`;
